module.exports = __webpack_public_path__ + "img/engine_one.dced6d3f.png";